import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";

import { DocumentInfoListResult } from "../models/document-info-list-result.model";
import { AppConfigService } from "./app-config.service";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class DocumentsService {
  constructor(
    @Inject("BASE_URL") private baseUrl: string,
    private http: HttpClient,
    private authService: AuthService,
    private translateService: TranslateService,
    private appConfigService: AppConfigService,
  ) {}

  async getDocumentsForProduct(
    productId: string,
  ): Promise<DocumentInfoListResult> {
    productId = encodeURIComponent(productId);
    const options = {
      headers: <{ [header: string]: string }>{
        Authorization: this.authService.getAuthorizationHeaderValue(),
        "Accept-Language": this.translateService.currentLang,
      },
    };
    return firstValueFrom(
      this.http.get<DocumentInfoListResult>(
        this.baseUrl + `api/v1/products/${productId}/documents`,
        options,
      ),
    );
  }

  public async getDownloadEndpointUrl(): Promise<string> {
    const appConfig = await this.appConfigService.getAppConfig();
    return `${appConfig.productDocumentsApiUrl}v1/download`;
  }
}
